<template>
    <div class="cars-list" :class="{'is-order': isOrder}">
        <div
            v-for="car in cars"
            :key="`car_${car.id}`"
            class="cars-list-item"
        >
            <CarItem
                class="car-btn"
                :class="{'is-order': isOrder}"
                :car="car"
                :route="{ name: 'GarageCarView', params: { carId: car.id } }"
                :selectedCar="selectedCar"
                @selectCar="selectCar"
            />
        </div>
        <div class="cars-list-item">
            <v-btn class="car-btn add" :class="{'is-order': isOrder}" elevation="0" @click="createCar()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:6px;">
                    <g clip-path="url(#clip0_517_3834)">
                        <path d="M8.0013 15.3333V0.666626M0.667969 7.99996H15.3346" stroke="#DA251C" stroke-width="1.8"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_517_3834">
                            <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>

                Добавить автомобиль
            </v-btn>
        </div>
    </div>
</template>

<script>
    import CarItem from '@/components/app/personal/garage/CarItem'

    export default {
        name: 'CarList',

        components: {
            CarItem,
        },

        props: {
            cars: { type: Array, default: () => [] },
            selectedCar: String,
        },

        data: () => ({
            // selectedCar: null,
        }),

        computed: {
            isOrder() {
                return this.$route.path.includes('online-order')
            },
        },

        methods: {
            createCar() {
                this.$router.push({
                    name: 'GarageCarEdit',
                })
            },
            selectCar(id) {
                // this.selectedCar = id + ''
                this.$emit('selectCar', id)
            },
        },
    }
</script>

<style>
    .cars-list {
        display: flex;
        gap: 14px;
        flex-wrap: wrap;
    }
    .cars-list-item {
        width: 100%;
        max-width: 32.5%;
    }
    .cars-list-item .v-btn__content {
        width: 100%;
    }
    .mobile .cars-list-item {
        max-width: 100%;
    }
    .car-btn {
        display: flex;
        flex-direction: column;
        height: 138px !important;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px;
        border-radius: 12px;
        border: 1.5px solid #E4E4E4;
        background: #FFF !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 16px 20px !important;
    }
    .car-btn.is-order {
        height: 112px !important;
    }
    .mobile .car-btn {
        display: flex;
        width: 100%;
        height: 134px !important;
        border-radius: 6px !important;
    }
    .mobile .car-btn.is-order {
        height: 154px !important;
    }
    .car-btn.add {
        width: 100% !important;
        height: 100%;
        justify-content: center;
        align-items: center;
        border: 1.5px solid #DA251C;
        color: #DA251C !important;
    }
    .car-btn.is-order.add {
        height: 112px !important;
    }
    .mobile .car-btn.add {
        height: 80px !important;
    }
</style>
